import { reveal } from './reveal';

export default function scrollReveal() {
  let selectors = [
    '.wp-block-sage-group',
    '.block.share',
    '.wp-block-cover',
    '.wp-block-media-text',
    '.wp-block-image',
    '.image-reveal',
    '.wp-block-gallery-wrapper',
    '.footer',
    '.wp-block-columns',
    '.news__post__image__inner',
  ];

  selectors = selectors.filter(function (selector) {
    return $(selector).length;
  });

  reveal(selectors.join(', '));
}
